module.exports = __webpack_public_path__ + "static/media/coin.9ee83f55.svg";